import type { DetectedPlugin } from './types';

export interface BlueprintDevice extends DetectedPlugin {
  kind: 'stock' | 'plugin';
}

export interface BlueprintDetection {
  devices: BlueprintDevice[];
  suggestions: BlueprintDevice[];
  pluginName?: string;
  /** The creator's version, not a proven minimum compatible version. */
  savedWithVersion?: string;
  /** Host versions must never populate a plug-in's required version. */
  savedWithHost?: boolean;
  stockStatus: 'stock' | 'external' | 'unknown';
  incomplete: boolean;
}

export const emptyBlueprintDetection = (): BlueprintDetection => ({
  devices: [],
  suggestions: [],
  stockStatus: 'unknown',
  incomplete: true,
});

export function blueprintDeviceLabel(device: BlueprintDevice): string {
  return device.kind === 'plugin' &&
    device.pluginType &&
    device.pluginType !== 'unknown'
    ? `${device.name} (${device.pluginType})`
    : device.name;
}

export function blueprintDeviceKey(device: BlueprintDevice): string {
  return `${device.kind}:${blueprintDeviceLabel(device).toLowerCase()}`;
}
